import {Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer} from "@mui/material";

export default function Privacy({privacy, hidePrivacy}) {
    return (
        <Drawer sx={{zIndex: "10000000", margin: "auto", maxWidth: "550px"}}
                PaperProps={{style: {margin: "auto", maxWidth: "550px"}, className: "SidePanel"}} anchor={"right"}
                open={privacy} onClose={hidePrivacy}>
            <DialogTitle>Privacy Policy</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    At sidebae, we are committed to protecting your privacy. <br/> <br/>
                    Our website is a global eBay listing aggregator that allows users to search and browse listings from
                    several locales on eBay. <br/> <br/>
                    When you use our website, you can choose to sign up by providing your first name, last name, and
                    email address via a Google or Microsoft login. This is optional, and you can still use our website
                    without signing up.
                    We use the email address provided to send search subscription notifications.<br/> <br/>
                    Our website allows users to block countries and sellers and save searches. This information is saved
                    in your account profile, and you can choose
                    to delete it at any time. <br/> <br/>
                    We store the last 100 recently viewed listing IDs for logged in users. This data is solely kept to
                    improve user experience.
                    <br/><br/>
                    We log API routes accessed for debugging and troubleshooting purposes. These logs do not contain
                    any personal information and
                    are used solely to improve the performance and functionality of our website. The logs are deleted as
                    soon as they are no longer needed.<br/><br/>
                    We will not share or sell your personal information to any third parties. <br/><br/>
                    We use cookies only for authentication purposes, to keep you logged in to your account. If you
                    choose to sign up, we use cookies to identify you as
                    a registered user and to provide you with access to your account and your saved searches, blocked
                    sellers, and blocked countries. If you would like to disable cookies, you can do so through your
                    browser settings, but please note that this may limit your ability to use certain features of our
                    website. <br/> <br/>
                    We may receive commission from eBay from items purchased using links from our
                    application. <br/><br/>
                    If you have any questions or concerns about our privacy policy, please do not hesitate to contact
                    us. <br/> <br/>
                    By using sidebae, you consent to the collection and use of your personal information in accordance
                    with this privacy policy.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <a style={{textDecoration: 'none'}}
                   href="mailto:amritmanhas@hotmail.com?subject = sidebae feedback"><Button>Contact</Button></a>
                <Button onClick={hidePrivacy}>Close</Button>
            </DialogActions>
        </Drawer>)
}